import React, { useEffect, useState, useRef } from "react";
import { api_url, logo, titleDescription, websiteName } from "../../config/Config";
import "react-responsive-modal/styles.css";
import _fetch from "../../config/api";
import toasted from "../../config/toast";
import { useTranslation } from "react-i18next";
import { ColorRing } from "react-loader-spinner";
import googlepay from "../../Assets/Image/g-pay.jpg";
import phonepay from "../../Assets/Image/phone-pay.jpg";
import paytm from "../../Assets/Image/paytm.jpg";
import upi from "../../Assets/Image/upi.jpg";
import { des_upi } from "../../config/Config";
import { qrcode } from "../../config/Config";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { FaDollarSign } from "react-icons/fa";

const INRDeposit = (props: any) => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = `${props.pageTitle} | ${titleDescription}`;
  });

  const [amount, setAmount] = useState<string>("");
  const [dollar, setDollar] = useState(0);
  const [bankDetails, setBankDetails] = useState({ bank_name: "", account_number: "", ifsc: "", address: "", qr_image: "" });
  const [trxId, setTrxId] = useState("");
  const [date, setDate] = useState("");
  const [receipt, setReceipt] = useState<any>(null);
  const [btnDisable, setbtnDisable] = useState(false);
  const [loading, setLoading] = useState(true);

  const usdAmount = amount ? (parseFloat(amount) / dollar).toFixed(2) : "";

  //for date field 

  const [displayDate, setDisplayDate] = useState(""); // Stores the formatted date for showing in input
  const [inputType, setInputType] = useState("text"); // Default type is text
  const inputRef = useRef(null);
  const formatDate = (value) => {
    if (!value) return "";
    const dateObj = new Date(value);
    return dateObj.toLocaleDateString("en-GB"); // Converts to DD/MM/YYYY format
  };

  useEffect(() => {
    getBalance();
  }, []);

  const getBalance = async () => {
    setLoading(true);
    const data2 = await _fetch(`${api_url}investment/getDollarPrice`, "GET", {}, {});
    const data3 = await _fetch(`${api_url}report/deposit-bankdetails`, "GET", {}, {});

    if (data2?.status === 'success') {
      setLoading(false);
      setDollar(data2?.data?.price);
    }
    if (data3?.status === 'success') {
      setLoading(false);
      setBankDetails(data3?.data);
    }
  }

  const handleRequest = async () => {
    setbtnDisable(true);
    setLoading(true);
    const dollarValue = amount ? parseFloat(amount) / dollar : 0;
    const data = {
      amount,
      dollar,
      dollarValue,
      trxId,
      date,
      receipt,
    };
    let res = await _fetch(`${api_url}fund/InrDeposite`, "POST", data);
    if (res?.status == "success") {
      toasted.success(res?.message);
      setbtnDisable(false);
      setLoading(false);
      setAmount('');
      setTrxId('');
      setDate('');
      setReceipt('');
      setDisplayDate('');
      if (receipt.current) receipt.current.value = '';
    } else {
      toasted.error(res?.message);
      setbtnDisable(false);
      setLoading(false);
    }
  };

  const handleFileChange = (e: any) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setReceipt(reader.result); // Set base64 string
      };
      reader.readAsDataURL(file); // Convert to base64
    }
  };

  return (
    <>
      <main>
        <div className="buy_section loader_main">
          {loading &&
            <div className="spinner_bg">

              <div className="color_ring">  <ColorRing
                visible={true}
                height="80"
                width="80"

                ariaLabel="blocks-loading"
                wrapperStyle={{}}
                wrapperClass="blocks-wrapper"
                colors={['#2b3892', '#2b3892', '#2b3892', '#2b3892', '#2b3892']}
              /></div>

            </div>
          }
          <div className="coustom_container">
            <div className="buy_top_sec">
              <h4>{t("DEPOSIT REQUEST")}</h4>
              <div className="inner_data">
              </div>
            </div>
            <div className="row cards_sec">
              {/* Left Column - Payment Form */}
              <div className="col-lg-6 col-md-6">
                <div className="card christmas_card mb-4">
                  <div className="card-body">
                    <div className="card_bottom_Sec">
                      <div className="upper-form">
                        {/* <h3 className="card-title">Bank Details</h3> */}
                        <form>
                          <div className="form-group">
                            <label>Bank Name</label>
                            <p><ArrowRightAltIcon /></p>
                            <input type="text" value={bankDetails?.bank_name} readOnly />
                          </div>

                          <div className="form-group">
                            <label>Account Number</label>
                            <p><ArrowRightAltIcon /></p>
                            <input
                              type="text"
                              value={bankDetails?.account_number}
                              readOnly
                            />
                          </div>

                          <div className="form-group">
                            <label>IFSC Code</label>
                            <p><ArrowRightAltIcon /></p>
                            <input type="text" value={bankDetails?.ifsc} readOnly />
                          </div>

                          <div className="form-group">
                            <label>Address</label>
                            <p><ArrowRightAltIcon /></p>
                            <input
                              type="text"
                              value={bankDetails?.address}
                              readOnly
                            />
                          </div>
                        </form>
                      </div>
                      <div className="middl-form-img">
                        <img src={logo} alt="" className=" img-fluid logo-middle" />
                      </div>

                      <div className="buy-section"></div>

                      <div className="buy-section">
                        <p className="select_amount">
                          <input
                            type="number"
                            placeholder="Enter INR Amount"
                            onChange={(e) => setAmount(e.target.value)}
                            value={amount}
                          />
                        </p>

                        {usdAmount && (
                          <p className="converted-amount">
                            <FaDollarSign style={{ marginRight: "5px" }} />
                            {usdAmount}
                          </p>
                        )}
                      </div>
                      <div className="buy-section">
                        <p className="select_amount">
                          <input
                            type="text"
                            placeholder="TRX ID"
                            onChange={(e) => setTrxId(e.target.value)}
                            value={trxId}
                          />
                        </p>
                      </div>
                      <div className="buy-section">
                        <p className="select_amount">
                          <input
                            ref={inputRef}
                            type={inputType}
                            value={inputType === "text" ? displayDate : date} // Show formatted date when type is text
                            placeholder="DD/MM/YYYY"
                            onFocus={() => {
                              setInputType("date"); // Change input type to date
                              setTimeout(
                                () => inputRef.current.showPicker(),
                                10
                              ); // Open date picker instantly
                            }}
                            onChange={(e) => {
                              setDate(e.target.value); // Store selected date in YYYY-MM-DD format
                              setDisplayDate(formatDate(e.target.value)); // Convert it to DD/MM/YYYY for display
                            }}
                            onBlur={() => {
                              setTimeout(() => {
                                if (!date) {
                                  setInputType("text"); // If no date selected, revert back to text
                                } else {
                                  setInputType("text"); // After selection, switch back to text with formatted date
                                }
                              }, 100); // Small delay to allow selection
                            }}
                          />
                        </p>
                      </div>
                      <div className="buy-section">
                        <p className="select_amount">
                          <input
                            type="file"
                            placeholder="Receipt"
                            onChange={handleFileChange}
                          />
                        </p>
                        <button
                          className="button_style w-100 mt-3"
                          onClick={() => handleRequest()}
                          disabled={btnDisable}
                        >
                          {t("Request")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Column - QR Code Section */}
              <div className="col-lg-6 col-md-6">
                <div className="card christmas_card qr_card">
                  <div className="card-body">
                    <h5 className="qr_title">SCAN HERE</h5>
                    <div className="payment_icons">
                      <img src={googlepay} alt="Google Pay" />
                      <img src={paytm} alt="Paytm" />
                      <img src={phonepay} alt="PhonePe" />
                      <img src={upi} alt="UPI" />
                    </div>
                    <div className="qr_section">
                      <h6>{websiteName}</h6>
                      <div className="qr_options">
                        <button className="active">UPI QR</button>
                        <button>CBDC QR</button>
                      </div>
                      <div className="qr_code">
                        <img src={bankDetails?.qr_image} alt="QR Code" />
                      </div>
                      <p className="vpa">VPA : {des_upi}</p>
                      <p className="company_name">
                        {" "}
                        {websiteName} GROWTH CAPITAL GROUP
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default INRDeposit;
